// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SYNnweE2YSZPbs {
  height: 32px;
  margin-right: var(--ds-space-050, 4px);
  padding-right: var(--ds-space-150, 10px);
  line-height: 32px;
  white-space: nowrap;
}
/**
 * @override
 * When popover menu is open, override the DynamicButton styles
 * to hold it in the active color state.
 */
.SYNnweE2YSZPbs.miGx1pUWndTsDd {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-pressed);
  color: var(--dynamic-button-pressed-text);
}
.SYNnweE2YSZPbs.miGx1pUWndTsDd svg circle {
  stroke: var(--dynamic-icon);
}
.SYNnweE2YSZPbs.miGx1pUWndTsDd:hover {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-pressed-hovered);
  color: var(--dynamic-button-pressed-text);
}
.SYNnweE2YSZPbs.miGx1pUWndTsDd:hover svg circle {
  stroke: var(--dynamic-icon);
}
.gni_uuRPFXM586 {
  margin-right: var(--ds-space-025, 2px);
}
.H12j0w_8UQ1P86 {
  min-width: 16px;
}
`, ""]);
// Exports
export var button = `SYNnweE2YSZPbs`;
export var buttonOpen = `miGx1pUWndTsDd`;
export var buttonText = `gni_uuRPFXM586`;
export var buttonIcon = `H12j0w_8UQ1P86`;
export default ___CSS_LOADER_EXPORT___;
